import React, { useMemo } from 'react';
import { TaxUtils } from '@bingads-webui-clientcenter/entity-utils';
import { TaxCertificateFilePicker } from '../../controls';
import { ViewTaxFormPropTypes } from '../../shapes';
import { BaseViewTaxFormList } from '../../utils';
import { FileScenarioMapping } from '../../constants';

const { getRequiredForCustomerClaimTaxExemption } = TaxUtils;

export const USViewTaxForm = ({
  i18n,
  filledData,
  taxCertification,
  taxFormMode,
  showLineByLineFormGroup,
  ownerAccountId,
  urlBuilder,
  showTaxCertLink,
  taxSchema,
  stateCode,
}) => {
  const additionalFormData = useMemo(() => ({ scenario: FileScenarioMapping[`US-${stateCode}`] }), [stateCode]);

  return (
    <div className="us-view-tax-form">
      <TaxCertificateFilePicker
        i18n={i18n}
        mtTaxCertification={taxCertification}
        taxFormMode={taxFormMode}
        showLineByLineFormGroup={showLineByLineFormGroup}
        ownerAccountId={ownerAccountId}
        urlBuilder={urlBuilder}
        showTaxCertLink={showTaxCertLink}
        taxCertLabel={getRequiredForCustomerClaimTaxExemption(i18n.getString(_TL_('Tax exemption certificate')), i18n)}
        additionalFormData={additionalFormData}
      />
      <BaseViewTaxFormList
        i18n={i18n}
        uiObject={filledData}
        taxSchema={taxSchema}
      />
    </div>
  );
};

USViewTaxForm.propTypes = ViewTaxFormPropTypes;
